import React, { useState } from 'react';
import Table, { TableSize } from '@components/Table';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import SearchPanel from '@components/SearchPanel';
import { translate } from '@utils/i18n';
import getColumnsDefinition from './columns';
import ImportForm from './ImportForm';
import useBackFlowTypes from './useBackFlowTypes';
import BackFlowTypeDetail from './BackFlowTypeDetail';
import { namespace } from './constants';
import '../../FormLibrary/styles.scss';
function BackFlowTypesContainer({ territoriesForSelect = [], frequenciesForSelect = [] }) {
    const [searchText, setSearchText] = useState('');
    const [isImportFormOpen, setisImportFormOpen] = useState(false);
    const [openBackFlowType, setOpenBackFlowType] = useState(null);
    const { backFlowTypes, loading, updateBackFlowType, addBackFlowType } = useBackFlowTypes(searchText, frequenciesForSelect);
    const onClickItem = (backFlowType) => {
        setOpenBackFlowType(backFlowType);
    };
    const onFormImported = (backFlowType) => {
        addBackFlowType(backFlowType);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "workspace__body" },
            React.createElement("div", { className: "workspace__major--listing" },
                React.createElement("div", { className: "workspace__header" },
                    React.createElement("div", { className: "header__main" },
                        React.createElement("h1", { className: "workspace__title" }, translate('title', { namespace })))),
                React.createElement("article", { id: "filters", className: "qmb-filters" },
                    React.createElement("button", { type: "button", className: "qmb-control mt-1 brushaway-button", onClick: () => {
                            setisImportFormOpen(true);
                        } },
                        React.createElement("i", { className: "fa-light fa-circle-plus" }),
                        translate('add_form', { namespace })),
                    React.createElement("div", { className: "filters__group--search" },
                        React.createElement(SearchPanel, { value: searchText, placeholder: translate('search', { namespace: 'filters' }), onChange: setSearchText }))),
                React.createElement("div", null,
                    loading && (React.createElement("div", { className: "loading-center" },
                        React.createElement(Loader, { size: LoaderSizes.xlarge }))),
                    !loading && (React.createElement(Table, { columns: getColumnsDefinition({ onClickItem, territories: territoriesForSelect }), data: backFlowTypes, size: TableSize.Full, variant: "listing" })),
                    !loading && backFlowTypes.length === 0 && (React.createElement("div", { className: "no-data-message" }, translate('no_data', { namespace })))))),
        React.createElement(BackFlowTypeDetail, { backFlowType: openBackFlowType, onClose: () => {
                setOpenBackFlowType(null);
            }, onSubmit: updateBackFlowType, territories: territoriesForSelect, frequencies: frequenciesForSelect }),
        React.createElement(ImportForm, { isImportFormOpen: isImportFormOpen, onClose: () => setisImportFormOpen(false), onFormImported: onFormImported })));
}
export default BackFlowTypesContainer;
